var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.64 13.996a.708.708 0 11-1.416 0 .708.708 0 011.416 0z",
    stroke: "#FF9E5A",
    strokeWidth: 0.584
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 7.432a1 1 0 100-2 1 1 0 000 2zM10.669 5.695a1 1 0 100-2 1 1 0 000 2z",
    fill: "#FF9E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 15.713l.056.056-7.29 3.1-7.29 3.1 3.1-7.29 3.1-7.29",
    stroke: "#FF9E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.101 7.426l4.154 4.153 4.133 4.134M7.706 11.615l2.797 2.797 2.783 2.784M5.775 15.09l1.952 1.952 1.942 1.942",
    stroke: "#FF9E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.064 7.39l.036.036",
    stroke: "#FF9E5A",
    strokeWidth: 1.167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.997 2.956c.078.15.134.314.163.49.15.916-.482 1.805-1.413 1.986",
    stroke: "#FF9E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 5.425a1.625 1.625 0 00-.502.122c-.857.357-1.276 1.364-.937 2.25M22.098 9.406a1.624 1.624 0 01-.18.484c-.458.808-1.508 1.103-2.347.66",
    stroke: "#FF9E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 10.585a1.625 1.625 0 00-.468-.22c-.89-.26-1.85.261-2.14 1.164",
    stroke: "#FF9E5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCelebrate;